export const ka = {
  title: 'PRODES (ლეგალური Amazon)',
  subtitle: 'წლიური, 6.25 ჰა, ლეგალური ამაზონი, INPE',
  content: [
    {
      label: 'ფუნქცია',
      value:
        'ტყეების გაჩეხვის მონიტორინგის სისტემა ბრაზილიის ლეგალური ამაზონისთვის, რომელსაც იყენებს ბრაზილიის მთავრობა საჯარო პოლიტიკის დასამყარებლად',
    },
    {
      label: 'რეზოლუცია',
      value: '6.25 ჰა',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'ბრაზილიის ლეგალური ამაზონი',
    },
    {
      label: 'წყარო',
      value: 'INPE',
    },
    {
      label: 'სიხშირე',
      value: 'ყოველწლიურად',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '2008-2021 წწ',
    },
    {
      label: 'გაფრთხილება',
      value:
        'PRODES იდენტიფიცირებს მხოლოდ 6,25 ჰექტარი ან მეტი ტყის გაწმენდას, ამიტომ ტყის დეგრადაცია ან ხანძრის ან შერჩევითი ჭრის შედეგად ტყის დეგრადაცია ან უფრო მცირე გაწმენდა არ არის გამოვლენილი. დაფარვის ზონების ხშირი ღრუბლის დაფარვამ შეიძლება შეცვალოს ტყეების გაჩეხვის წელი. მოხსენებული წელი არის ანალიტიკოსების მიერ ტყის გაჩეხვის პირველი წელი, მაგრამ ეს სულაც არ შეესაბამება ტყეების გაჩეხვის წელს, თუ წინა წლებში ლანდშაფტი ღრუბლებით იყო დაფარული.',
    },
    {
      label: 'ლიცენზია',
      value: 'Creative Commons BY SA 3.0',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'PRODES პროექტი მონიტორინგს უწევს ბრაზილიის ამაზონისა და სერადოს ბიომებში ტყეების გაჩეხვას და აწარმოებს რეგიონში ტყეების გაჩეხვის წლიურ მაჩვენებლებს 1988 წლიდან. ბრაზილიის მთავრობა იყენებს ამ მაჩვენებლებს საჯარო პოლიტიკის დასამყარებლად, მათ შორის ამაზონის ბიომში კრედიტზე ხელმისაწვდომობის დასადგენად, ტყის გაჩეხვის შემცირების მიზნების დასახვას და ფინანსების მოძიებას ტყეების გაჩეხვის შესამცირებლად. PRODES ისტორიულად იყენებდა Landsat 5 სურათებს, მაგრამ ახლა ასევე აერთიანებს სურათებს Landsat 7 და 8, CBERS-2, CBERS-2B, Resourcesat-1 და UK2-DMC. PRODES-ს მართავს კოსმოსური კვლევის ეროვნული ინსტიტუტი (INPE) გარემოს დაცვის სამინისტროსთან (MMA) და ბრაზილიის გარემოსა და განახლებადი ბუნებრივი რესურსების ინსტიტუტთან (IBAMA) თანამშრომლობით. 2002 წლიდან PRODES-ის ყველა მონაცემი საჯაროდ ხელმისაწვდომია ონლაინ. შეყვანილი სურათები 220 Landsat-ის თითოეული ნაკვალევისთვის, რომელიც ფარავს ბრაზილიურ ამაზონს და სერადოს, შეირჩევა მათი ღრუბლის ნაკლებობისა და მათი გადაღების თარიღის მიხედვით. PRODES სისტემა იყენებს სეზონურ წელს, დაწყებული 1 აგვისტოდან, ყოველწლიური ტყის გაჩეხვის გამოსათვლელად, ამიტომ სურათები შეირჩევა რაც შეიძლება ახლოს ამ თარიღთან (ზოგადად, ივლისიდან, აგვისტოდან და სექტემბრიდან). 2003 წლიდან 2005 წლამდე ანალიტიკოსები იყენებდნენ გამოსახულების ტრანსფორმაციას მცენარეულობის, ნიადაგისა და ჩრდილის კომპონენტების დასადგენად პროგრამის SPRING-ის გამოყენებით. ეს კომპონენტები იყო სეგმენტირებული და კლასიფიცირებული კლასებად ტყის, არატყის, ტყის გაჩეხვის სამიზნე წელს, წინა ტყის გაჩეხვის, ღრუბლებისა და წყლის კლასებად, რომლებიც შემდეგ ხელებით სწორდება ექსპერტების მიერ. 2005 წლიდან დაწყებული იქნა ახალი მეთოდოლოგია, რომელიც იყენებს ღია კოდის TerraAmazon პლატფორმას. პლატფორმა საშუალებას აძლევს PRODES-ის ანალიზს იყოს უფრო ერთგვაროვანი და შეუძლია სხვადასხვა თანამგზავრების გამოსახულების ჩართვა. როგორც ადრე, სურათები შეირჩევა ისე, რომ იყოს ღრუბლოვანი რაც შეიძლება თავისუფალი. შემდეგ გამოსახულებები ნიღბავს, რათა გამოირიცხოს არატყის, წინა ტყის გაჩეხვა და წყალი წინა წლის ანალიზის გამოყენებით. შემდეგ ანალიტიკოსები ხაზს უსვამენ გაჩეხილ პოლიგონებს წინა წლის ხელუხლებელ ტყეში. ეს მონაცემთა ნაკრები გვიჩვენებს ყოველწლიურ ტყის გაჩეხვას 2008-2020 წლებში Nrazilian Legal Amazon-ში.',
  },
  citation: {
    label: 'ციტატა',
    value:
      "კოსმოსური კვლევის ეროვნული ინსტიტუტი (INPE). 'ხელს უწყობს ტყეების განადგურებას.' ხელმისაწვდომია Global Forest Watch-ის მეშვეობით [თარიღი]. www.globalforestwatch.org",
  },
};
